import * as React from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import MenuItem from '@mui/material/MenuItem';
import Drawer from '@mui/material/Drawer';
import MenuIcon from '@mui/icons-material/Menu';
import ToggleColorMode from './ToggleColorMode';
import { useTheme } from '@mui/system';
import Person2Icon from '@mui/icons-material/Person2';
import { useNavigate } from 'react-router-dom';
import darkModeLogo from '../assets/logo/darkmodelogo.png';
import lightModeLogo from '../assets/logo/lightmodelogo.png';

const logoStyle = {
  width: '35px',
  height: 'auto',
  cursor: 'pointer',
  margin: '10px'
};

function LoggedInBar({ mode, toggleColorMode }) {
  const [open, setOpen] = React.useState(false);

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  const whiteLogos = [darkModeLogo];
  const darkLogos = [lightModeLogo];

  const theme = useTheme();
  const logos = theme.palette.mode === 'light' ? darkLogos : whiteLogos;

  const scrollToSection = (sectionId) => {
    const sectionElement = document.getElementById(sectionId);
    const offset = 128;
    if (sectionElement) {
      const targetScroll = sectionElement.offsetTop - offset;
      sectionElement.scrollIntoView({ behavior: 'smooth' });
      window.scrollTo({
        top: targetScroll,
        behavior: 'smooth'
      });
      setOpen(false);
    }
  };

  const signOut = () => {
    // Clear stored tokens
    localStorage.removeItem('accessToken'); // Remove the access token
    // alert('You have successfully signed out!');
    // Redirect to login page or home page
    window.location.href = '/'; // Adjust as needed
  };

  const navigate = useNavigate();

  return (
    <div>
      <AppBar
        position="fixed"
        sx={{
          boxShadow: 0,
          bgcolor: 'transparent',
          backgroundImage: 'none',
          mt: 2
        }}>
        <Container maxWidth="lg">
          <Toolbar
            variant="regular"
            sx={(theme) => ({
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              flexShrink: 0,
              borderRadius: '999px',
              bgcolor:
                theme.palette.mode === 'light' ? 'rgba(255, 255, 255, 0.4)' : 'rgba(0, 0, 0, 0.4)',
              backdropFilter: 'blur(24px)',
              maxHeight: 40,
              border: '1px solid',
              borderColor: 'divider',
              boxShadow:
                theme.palette.mode === 'light'
                  ? `0 0 1px rgba(85, 166, 246, 0.1), 1px 1.5px 2px -1px rgba(85, 166, 246, 0.15), 4px 4px 12px -2.5px rgba(85, 166, 246, 0.15)`
                  : '0 0 1px rgba(2, 31, 59, 0.7), 1px 1.5px 2px -1px rgba(2, 31, 59, 0.65), 4px 4px 12px -2.5px rgba(2, 31, 59, 0.65)'
            })}>
            <Box
              sx={{
                flexGrow: 1,
                display: 'flex',
                alignItems: 'center',
                ml: '-18px',
                px: 0
              }}>
              <img onClick={() => navigate('/')} src={logos} style={logoStyle} alt="logo" />
              <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
                <MenuItem onClick={() => navigate('/categories')} sx={{ py: '6px', px: '12px' }}>
                  <Typography variant="body2" color="text.primary">
                    Cases
                  </Typography>
                </MenuItem>
                <MenuItem onClick={() => navigate('/tiers')} sx={{ py: '6px', px: '12px' }}>
                  <Typography variant="body2" color="text.primary">
                    Tiers
                  </Typography>
                </MenuItem>
                <MenuItem onClick={() => navigate('/faq')} sx={{ py: '6px', px: '12px' }}>
                  <Typography variant="body2" color="text.primary">
                    FAQs
                  </Typography>
                </MenuItem>
                <MenuItem onClick={() => navigate('/exam-day')} sx={{ py: '6px', px: '12px' }}>
                  <Typography variant="body2" color="text.primary">
                    Exam Day Tips
                  </Typography>
                </MenuItem>
                {/* <MenuItem
                  onClick={() => scrollToSection('testimonials')}
                  sx={{ py: '6px', px: '12px' }}>
                  <Typography variant="body2" color="text.primary">
                    Testimonials
                  </Typography>
                </MenuItem>
                <MenuItem
                  onClick={() => scrollToSection('highlights')}
                  sx={{ py: '6px', px: '12px' }}>
                  <Typography variant="body2" color="text.primary">
                    Highlights
                  </Typography>
                </MenuItem>
                <MenuItem onClick={() => scrollToSection('pricing')} sx={{ py: '6px', px: '12px' }}>
                  <Typography variant="body2" color="text.primary">
                    Pricing
                  </Typography>
                </MenuItem>
                <MenuItem onClick={() => scrollToSection('faq')} sx={{ py: '6px', px: '12px' }}>
                  <Typography variant="body2" color="text.primary">
                    FAQ
                  </Typography>
                </MenuItem> */}
              </Box>
            </Box>
            <Box
              sx={{
                display: { xs: 'none', md: 'flex' },
                gap: 0.5,
                alignItems: 'center'
              }}>
              <Box sx={{ maxWidth: '32px' }}>
                <Button
                  variant="text"
                  onClick={() => navigate('/profile')}
                  size="small"
                  aria-label="button to toggle theme"
                  sx={{ minWidth: '32px', height: '32px', p: '4px' }}>
                  <Person2Icon fontSize="small" />
                </Button>
              </Box>
              <ToggleColorMode mode={mode} toggleColorMode={toggleColorMode} />
              <Button
                color="primary"
                variant="contained"
                size="small"
                component="a"
                onClick={signOut}
                // target="_blank"
              >
                Sign Out
              </Button>
            </Box>
            {/* COLLAPSED BAR */}
            <Box sx={{ display: { sm: '', md: 'none' } }}>
              <Button
                variant="text"
                color="primary"
                aria-label="menu"
                onClick={toggleDrawer(true)}
                sx={{ minWidth: '30px', p: '4px' }}>
                <MenuIcon />
              </Button>
              <Drawer anchor="right" open={open} onClose={toggleDrawer(false)}>
                <Box
                  sx={{
                    minWidth: '60dvw',
                    p: 2,
                    backgroundColor: 'background.paper',
                    flexGrow: 1
                  }}>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'row-reverse',
                      alignItems: 'end',
                      flexGrow: 1
                    }}>
                    <ToggleColorMode mode={mode} toggleColorMode={toggleColorMode} />
                    <Box sx={{ maxWidth: '32px' }}>
                      <Button
                        variant="text"
                        onClick={() => navigate('/profile')}
                        size="small"
                        aria-label="button to toggle theme"
                        sx={{ minWidth: '32px', height: '32px', p: '4px' }}>
                        <Person2Icon fontSize="small" />
                      </Button>
                    </Box>
                  </Box>
                  {/* collapsed navmenu */}
                  <MenuItem onClick={() => navigate('/categories')}>Cases</MenuItem>
                  <MenuItem onClick={() => navigate('/tiers')}>Tiers</MenuItem>
                  <MenuItem onClick={() => navigate('/faq')}>FAQs</MenuItem>
                  <MenuItem onClick={() => navigate('/exam-day')}>Exam Day Tips</MenuItem>
                  {/* <MenuItem onClick={() => scrollToSection('testimonials')}>Testimonials</MenuItem> */}
                  {/* <MenuItem onClick={() => scrollToSection('highlights')}>Highlights</MenuItem> */}
                  {/* <MenuItem onClick={() => scrollToSection('pricing')}>Pricing</MenuItem> */}
                  {/* <MenuItem onClick={() => scrollToSection('faq')}>FAQ</MenuItem> */}
                  <Divider />
                  <Button
                    color="primary"
                    variant="contained"
                    size="small"
                    component="a"
                    onClick={signOut}
                    // target="_blank"
                  >
                    Sign Out
                  </Button>
                </Box>
              </Drawer>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
    </div>
  );
}

LoggedInBar.propTypes = {
  mode: PropTypes.oneOf(['dark', 'light']).isRequired,
  toggleColorMode: PropTypes.func.isRequired
};

export default LoggedInBar;
